import { INV_GUARANTEE_DISPOSITION } from '@signifyd/http'
import { RecommendationDisposition } from 'caseReport/networkCalls/recommendations/types'

export const isRecommendationOrder = (
  guaranteeDisposition?: INV_GUARANTEE_DISPOSITION | null,
  recommendedDecisionDisposition?: RecommendationDisposition | null
): boolean => !guaranteeDisposition && !!recommendedDecisionDisposition
